import { Component, inject, input, OnInit, signal } from '@angular/core';
import { Select } from 'primeng/select';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { FileUploadComponent } from '../../../ui/file-upload/file-upload.component';
import { DataUtils, fileToBlob, ISelectItem } from '../../../utils/data.util';
import { Category, ImportService } from '../../../api';
import { catchError, of, switchAll, switchMap } from 'rxjs';
import { Message } from 'primeng/message';
import { ImportFileService } from './import-file.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export type TImportState = 'NOT_STARTED' | 'IN_PROGRESS' | 'SUCESS' | 'FAIL';

@Component({
  selector: 'app-import-file',
  imports: [
    Select,
    TranslatePipe,
    FormsModule,
    NgClass,
    FileUploadComponent,
    Message,
  ],
  templateUrl: './import-file.component.html',
  styleUrl: './import-file.component.scss',
})
export class ImportFileComponent implements OnInit {
  selectedCategory?: ISelectItem<Category>;
  categories: Array<ISelectItem<Category>> = [];
  translationPrefix = input.required<string>();
  dataUtils = inject(DataUtils);
  importFileService = inject(ImportFileService);
  file?: File;

  importState = signal<TImportState>('NOT_STARTED');
  private importService = inject(ImportService);

  ngOnInit() {
    this.categories = this.dataUtils.mapCategories();
  }

  onFileSelected(file?: File) {
    this.file = file;
  }

  uploadTemplate() {
    this.importState.set('IN_PROGRESS');
    if (this.selectedCategory && this.file) {
      fileToBlob(this.file)
        .pipe(
          switchMap(res => {
            if (this.selectedCategory && this.file) {
              return this.importService.importAssets(
                self.crypto.randomUUID(),
                this.selectedCategory.id,
                'text/csv',
                this.file.size,
                res
              );
            } else {
              this.importState.set('FAIL');
              return of(false);
            }
          }),
          catchError(error => {
            this.importState.set('FAIL');
            return of(false);
          })
        )
        .subscribe({
          next: res => {
            this.importState.set('SUCESS');
            this.importFileService.fileUploaded.next();
          },
          error: err => {
            this.importState.set('FAIL');
          },
        });
    }
  }
}
